import { styled } from "@mui/material";
import Button from "../../Button";

export const SavedColorsWrapper = styled("section")`
  display: flex;
  gap: ${(props) => props.theme.wsc.spacing[2]};
  flex-direction: column;
`;

export const SavedColorsTitleSection = styled("section")`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SavedColorsTitle = styled("span")`
  ${(props) => `font-size: ${props.theme.wsc.typography.body2bold.fontSize};
  font-weight: ${props.theme.wsc.typography.body2bold.fontWeight};
  color: ${props.theme.wsc.palette.neutral[0]};`}
`;

export const ColorsContainer = styled("section")`
  display: flex;
  flex-wrap: wrap;
  gap: 0.761rem;
`;

export const AddButton = styled(Button)`
  &.MuiButtonBase-root {
    min-width: initial;
    padding: ${(props) =>
      `${props.theme.wsc.spacing[1]} ${props.theme.wsc.spacing[0]}`};
  }
`;
